import { useSelector } from "react-redux";
import DashboardLayout from "cxfcomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "cxfcomponents/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card";
import SoftTypography from "components/SoftTypography";
import { useNavigate } from "react-router-dom";
import { useSlugFlow } from "hooks/useSlugFlow";
import defaultFlowIcon from "assets/images/for-flow/flow-icon-list-view.svg";
import StatusBadge from "cxfcomponents/StatusBadge";
import Icon from "@mui/material/Icon";
import SoftButton from "components/SoftButton";
import { FlowTabs } from "./components/tabs";
import "./style.css";
import { useRef, useState } from "react";
import { EditPropertiesDialog } from "./components/editProperties";
import { getLocalDateTimeString, formatDateAndTime } from "helpers/common";
import DefaultUserAvatar from "layouts/pages/account/components/Header/components/DefaultUserAvatar";
import { useResourceListener } from "hooks/useResourceListener";

export const Flow = () => {
   const navigate = useNavigate();
   const { flow, handleFetchFlows } = useSlugFlow();
   const { users } = useSelector((store) => store.portal.users);
   const tabMap = useRef(new Map());
   const [openEditProperties, setOpenEditProperties] = useState(false);
   useResourceListener("flowsSharingUpdate", handleFetchFlows);

   const getOwnerDeveloper = () => {
      const foundUser = users?.find((user) => user.auth0_id === flow?.created_by_id);

      return foundUser;
   };

   const handleEdit = () => {
      if (flow.trashed) return;

      let tab = tabMap.current.get(flow.id);

      if (!tab || tab.closed) {
         tab = window.open(`/designer/${flow.id}`, "_blank");
         tabMap.current.set(flow.id, tab);
      } else {
         tab.focus();
      }
   };

   if (!flow) return <></>;

   return (
      <>
         <div
            style={{
               padding: "8px",
               position: "sticky",
               top: 0,
               zIndex: 1000,
               backgroundColor: "var(--main-bg-color)"
            }}
         >
            <DashboardNavbar title={flow?.name ?? ""} />
         </div>
         <DashboardLayout
            sx={{
               display: "flex",
               flexDirection: "column",
               minHeight: "100vh",
               height: "100vh",
               boxSizing: "border-box",
               overflow: "hidden"
            }}
         >
            <SoftBox
               mt={-3}
               sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0
               }}
            >
               <Card
                  className="flow"
                  sx={{
                     backgroundColor: "transparent !important",
                     overflow: "hidden",
                     boxShadow: "none !important",
                     display: "flex",
                     flexDirection: "column",
                     flex: 1,
                     minHeight: 0
                  }}
               >
                  <Card
                     sx={{
                        overflow: "visible",
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        minHeight: 0
                     }}
                  >
                     {/* Top Part */}
                     <SoftBox
                        alignItems="flex-start"
                        justifyContent="space-between"
                        sx={{
                           display: {
                              sm: "block",
                              lg: "flex"
                           },
                           padding: {
                              sm: "12px 32px 20px 32px",
                              lg: "48px 64px 46px 64px"
                           },
                           flexWrap: {
                              sm: "wrap",
                              lg: "noWrap"
                           },
                           columnGap: "40px",
                           height: "max-content"
                        }}
                     >
                        <SoftBox display="flex" alignItems="flex-start" sx={{ marginBottom: { sm: "16px", lg: "0" }, position: "relative" }}>
                           {/* Go Back Button just above the flow logo */}
                           <SoftBox sx={{ position: "absolute", top: "-32px", left: 0 }}>
                              <button
                                 onClick={() => navigate(-1)}
                                 style={{
                                    alignItems: "center",
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    display: "flex",
                                    maxWidth: "max-content",
                                    fontSize: "14px",
                                    padding: 0
                                 }}
                              >
                                 <SoftBox
                                    sx={{
                                       display: "grid",
                                       marginRight: "16px",
                                       placeContent: "center",
                                       fontSize: "28px",
                                       fontWeight: "300"
                                    }}
                                 >
                                    <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                       <path d="M8.77783 0.5L0.999657 8.27817L8.77783 16.0563" stroke="#7B809A" />
                                    </svg>
                                 </SoftBox>
                                 <SoftTypography sx={{ fontWeight: "normal", fontSize: "14px" }}>Go back</SoftTypography>
                              </button>
                           </SoftBox>
                           <SoftBox
                              component="img"
                              borderRadius="16px"
                              marginRight="40px"
                              sx={{
                                 objectFit: "cover",
                                 width: {
                                    sm: "120px",
                                    lg: "174px"
                                 },
                                 minHeight: {
                                    sm: "120px",
                                    lg: "164px"
                                 },
                                 maxHeight: {
                                    sm: "120px",
                                    lg: "164px"
                                 },
                                 border: "0.5px solid #e6e6e6"
                              }}
                              src={flow.logo ? `${flow.logo}?v=${flow.logoUpdatedAt ?? flow.updated_date_time ?? ""}` : defaultFlowIcon}
                           />
                           <SoftBox
                              sx={{
                                 maxWidth: {
                                    lg: "clamp(100px, 32vw, 540px)"
                                 },
                                 display: "flex",
                                 flexDirection: "column",
                                 minHeight: "164px"
                              }}
                           >
                              <SoftTypography fontSize="24px" fontWeight="bold" lineHeight="1.25" marginBottom="8px" className="white-to-dark">
                                 {flow.name}
                              </SoftTypography>
                              <StatusBadge status={flow.trashed ? "deleted" : flow.shared_status} />
                              <SoftTypography sx={{ margin: "auto 0", fontSize: "13px" }}>{flow.description ? flow.description : "No description"}</SoftTypography>
                              <SoftBox display="flex" sx={{ marginTop: "auto" }}>
                                 <SoftButton
                                    sx={{
                                       margin: "0 20px 0 0",
                                       padding: "12px !important"
                                    }}
                                    variant="gradient"
                                    size="medium"
                                    color="primary"
                                    onClick={handleEdit}
                                    disabled={flow.trashed}
                                 >
                                    <svg style={{ marginRight: "8px" }} width="12" height="12" viewBox="0 1 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                       <g clipPath="url(#clip0_9_6634)">
                                          <path
                                             d="M4.12516 0.914062V3.66406H5.04183V5.03906H2.29183C1.78308 5.03906 1.37516 5.44698 1.37516 5.95573V7.33073H0.458496V10.0807H3.2085V7.33073H2.29183V5.95573H5.04183V7.33073H4.12516V10.0807H6.87516V7.33073H5.9585V5.95573H8.7085V7.33073H7.79183V10.0807H10.5418V7.33073H9.62516V5.95573C9.62516 5.44698 9.21725 5.03906 8.7085 5.03906H5.9585V3.66406H6.87516V0.914062H4.12516Z"
                                             fill="white"
                                          />
                                       </g>
                                       <defs>
                                          <clipPath id="clip0_9_6634">
                                             <rect width="11" height="11" fill="white" transform="translate(0 -0.00292969)" />
                                          </clipPath>
                                       </defs>
                                    </svg>
                                    open
                                 </SoftButton>
                                 <SoftButton
                                    sx={{
                                       padding: "12px !important"
                                    }}
                                    variant="gradient"
                                    size="medium"
                                    color="primary"
                                    onClick={() => setOpenEditProperties(true)}
                                 >
                                    <Icon sx={{ fontSize: "500px !important", marginRight: "8px" }}>edit</Icon>
                                    properties
                                 </SoftButton>
                              </SoftBox>
                           </SoftBox>
                        </SoftBox>
                        <SoftBox
                           sx={{
                              flexBasis: {
                                 lg: "max-content"
                              },
                              flexShrink: 0
                           }}
                        >
                           <SoftTypography className="white-to-dark" fontSize="12px" marginBottom="4px">
                              <span style={{ opacity: 0.6, width: "76px", display: "inline-block" }}>Version:</span>
                              <span
                                 style={{
                                    marginLeft: "10px"
                                 }}
                              >
                                 02.03.22
                              </span>
                           </SoftTypography>
                           <SoftTypography sx={{ display: "flex", alignItems: "flexStart" }} className="white-to-dark" fontSize="12px" marginBottom="4px">
                              <span style={{ opacity: 0.6, width: "76px", display: "inline-block" }}>Date Created:</span>
                              <span
                                 style={{
                                    marginLeft: "10px",
                                    maxWidth: "100px",
                                    whiteSpace: "break-spaces"
                                 }}
                              >
                                 {formatDateAndTime(getLocalDateTimeString(flow.created_date_time)) || ""}
                              </span>
                           </SoftTypography>
                           <SoftTypography sx={{ display: "flex", alignItems: "flexStart" }} className="white-to-dark" fontSize="12px" marginBottom="4px">
                              <span style={{ opacity: 0.6, width: "76px", display: "inline-block" }}>Last Edited:</span>
                              <span
                                 style={{
                                    marginLeft: "10px",
                                    maxWidth: "100px",
                                    whiteSpace: "break-spaces"
                                 }}
                              >
                                 {(flow.updated_date_time && formatDateAndTime(getLocalDateTimeString(flow.updated_date_time))) || ""}
                              </span>
                           </SoftTypography>
                           <SoftBox display="flex" alignItems="center">
                              <SoftTypography className="white-to-dark" opacity={0.6} fontSize="12px">
                                 Developed By:
                              </SoftTypography>
                              {getOwnerDeveloper() && (
                                 <>
                                    {getOwnerDeveloper().image && getOwnerDeveloper().image.trim() !== "" ? (
                                       <SoftBox
                                          component="img"
                                          src={getOwnerDeveloper().image}
                                          alt={`${getOwnerDeveloper().first_name} ${getOwnerDeveloper().last_name}`}
                                          sx={{
                                             width: "24px",
                                             height: "24px",
                                             borderRadius: "32px",
                                             border: ".5px solid white !important",
                                             objectFit: "cover",
                                             margin: "0 8px"
                                          }}
                                       />
                                    ) : (
                                       <DefaultUserAvatar
                                          firstName={getOwnerDeveloper().first_name}
                                          lastName={getOwnerDeveloper().last_name}
                                          variant={"rounded"}
                                          size="xs"
                                          border=".5px solid white !important"
                                          disableFocusListener={false}
                                          disableTouchListener={false}
                                          open={false}
                                       />
                                    )}
                                    <SoftTypography component="span" className="white-to-dark" fontSize="12px" sx={{ textDecoration: "underline" }}>
                                       {getOwnerDeveloper().first_name} {getOwnerDeveloper().last_name}
                                    </SoftTypography>
                                 </>
                              )}
                           </SoftBox>
                        </SoftBox>
                     </SoftBox>
                     {/* End of Top Part */}
                     <SoftBox sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
                        <FlowTabs />
                     </SoftBox>
                  </Card>
               </Card>
            </SoftBox>
            <EditPropertiesDialog isOpen={openEditProperties} onClose={() => setOpenEditProperties(false)} />
         </DashboardLayout>
      </>
   );
};
